import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/home-topbar-bg.5427e4fd (1).svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/banner.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/heart.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/hospital-svgrepo-com.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/image 310.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/Line 53.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/Line 54.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/microscope-.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/note.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/picture.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/home/shape.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/svg/logo-blue.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/common/home/layout/center-search.tsx");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/common/home/layout/ClinicCard.tsx");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/common/home/layout/laboratory-city.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/home/layout/medical-centers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/home/layout/service-card.tsx");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/common/search-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/loader/LoaderError.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselContent","CarouselItem","CarouselPrevious","CarouselNext"] */ "/opt/darmanshirin-front-new/src/components/ui/carousel.tsx");
